import React from 'react'
import { Box, Flex } from 'pcln-design-system'
import { Modal } from 'pcln-modal'
import Form from '../SearchForm/Form'
import { handleSubmitForExpressDeals } from '../SearchForm/utils'
import StyledHeading from '../../StyledHeading'
import useExpressDealModal from '../../CustomHooks/useExpressDealModal'
import { ANALYTICS_CATEGORY_HOTELS } from '../../../constants/analytics'
import { PromoDeal } from '../constants'

const PRIMARY_HEADING_TEXT = 'Search for Express Deal®'
const SECONDARY_HEADING_TEXT =
  'Save up to 60% Fast and Easy - No Bidding Required!'

export default function ExpressDealModal({
  isModalOpen,
  gaCategory = ANALYTICS_CATEGORY_HOTELS,
  qsKey = 'modal',
  qsValue = 'express-deals'
}: {
  isModalOpen: boolean
  gaCategory?: string
  qsKey?: string
  qsValue?: string
}) {
  const { closeModal } = useExpressDealModal(qsKey, qsValue)

  return (
    <Modal
      enableOverflow
      ariaLabel="Express Deals Search Modal"
      isOpen={isModalOpen}
      onClose={closeModal}
      timeout={50}
      width={[1, 750]}
    >
      <Flex
        flexDirection="column"
        pb={4}
        pt={[2, null, null, 4]}
        px={[2, null, null, 2]}
      >
        <StyledHeading
          aceContent={['SITE-X.HOMEPAGE.SEARCHAREA.EXPRESSDEALS.TITLE']}
          fontSize={[3, 3, null, 5]}
          pb={2}
          tag="h1"
          text={PRIMARY_HEADING_TEXT}
        />
        <StyledHeading
          fontSize={2}
          color="text.light"
          tag="h2"
          text={SECONDARY_HEADING_TEXT}
        />
      </Flex>
      <Box pb={4} px={[2, null, null, 2]}>
        <Form
          onSubmit={values =>
            handleSubmitForExpressDeals({ ...values, gaCategory })
          }
          promoDeal={PromoDeal.EXPRESS_DEAL}
        />
      </Box>
    </Modal>
  )
}
